import type { PlanKey } from "./planKeys.js";

const baseFeatures = {
  feature_sdk_api: true,
  feature_signed_production_permits: true,
  feature_sandbox_bot_modes: true,
  feature_basic_audit: true,
  feature_manual_approval: false,
  feature_limited_manual_approval: false,
  feature_standard_webhooks: false,
  feature_policy_simulation: false,
  feature_approval_groups: false,
  feature_escalation_rules: false,
  feature_audit_export: false,
  feature_sso: false,
  feature_scim: false,
  feature_advanced_rbac: false,
  feature_audit_streaming: false,
  feature_sla: false,
  feature_invoice_billing: false,
  feature_connector_hubspot: false,
  feature_connector_intercom: false,
  feature_connector_zendesk: false
};

export const planEntitlementTemplates: Record<PlanKey, Record<string, unknown>> = {
  free: {
    plan_key: "free",
    included_production_controlled_actions_per_month: 10,
    included_sandbox_evaluations_per_month: 500,
    included_members: 3,
    max_members: 3,
    max_extra_paid_members: 0,
    included_workspaces: 1,
    max_workspaces: 1,
    max_extra_paid_workspaces: 0,
    allow_extra_workspaces: false,
    max_action_types: 1,
    max_active_production_policies: 1,
    audit_retention_days: 7,
    allow_paid_production_overage: false,
    ...baseFeatures,
    feature_limited_manual_approval: true
  },
  starter: {
    plan_key: "starter",
    included_production_controlled_actions_per_month: 500,
    included_sandbox_evaluations_per_month: 5000,
    included_members: 5,
    max_members: 15,
    max_extra_paid_members: 10,
    included_workspaces: 1,
    max_workspaces: 1,
    max_extra_paid_workspaces: 0,
    allow_extra_workspaces: false,
    max_action_types: 3,
    max_active_production_policies: 5,
    audit_retention_days: 30,
    allow_paid_production_overage: true,
    extra_member_unit_usd: 10,
    production_overage_unit_usd: 0.05,
    ...baseFeatures,
    feature_manual_approval: true,
    feature_standard_webhooks: true,
    feature_policy_simulation: true
  },
  pro: {
    plan_key: "pro",
    included_production_controlled_actions_per_month: 5000,
    included_sandbox_evaluations_per_month: 50000,
    included_members: 25,
    max_members: 75,
    max_extra_paid_members: 50,
    included_workspaces: 3,
    max_workspaces: 10,
    max_extra_paid_workspaces: 7,
    allow_extra_workspaces: true,
    max_action_types: 10,
    max_active_production_policies: 50,
    audit_retention_days: 365,
    allow_paid_production_overage: true,
    extra_member_unit_usd: 12,
    extra_workspace_unit_usd: 49,
    production_overage_unit_usd: 0.015,
    ...baseFeatures,
    feature_manual_approval: true,
    feature_standard_webhooks: true,
    feature_policy_simulation: true,
    feature_approval_groups: true,
    feature_escalation_rules: true,
    feature_audit_export: true
  },
  enterprise: {
    plan_key: "enterprise",
    included_production_controlled_actions_per_month: 1_000_000,
    included_sandbox_evaluations_per_month: 1_000_000,
    included_members: 100,
    max_members: 10_000,
    max_extra_paid_members: 0,
    included_workspaces: 100,
    max_workspaces: 10_000,
    max_extra_paid_workspaces: 0,
    allow_extra_workspaces: true,
    max_action_types: 100,
    max_active_production_policies: 1000,
    audit_retention_days: 3650,
    allow_paid_production_overage: true,
    ...baseFeatures,
    feature_manual_approval: true,
    feature_standard_webhooks: true,
    feature_policy_simulation: true,
    feature_approval_groups: true,
    feature_escalation_rules: true,
    feature_audit_export: true,
    feature_sso: true,
    feature_scim: true,
    feature_advanced_rbac: true,
    feature_audit_streaming: true,
    feature_sla: true,
    feature_invoice_billing: true
  }
};

export const planEntitlementTemplate = (planKey: string): Record<string, unknown> => {
  if (
    planKey === "starter" ||
    planKey === "pro" ||
    planKey === "enterprise" ||
    planKey === "free"
  ) {
    return { ...planEntitlementTemplates[planKey] };
  }
  return { ...planEntitlementTemplates.free, plan_key: planKey };
};
